import { LANG, SITEMAP_URL } from './config';

const proxies = {
  tr: [
    { Gündem: `/Publisher/publisher-gundem.rss`, isCategory: true },
    { Spor: `/Publisher/publisher-spor.rss`, isCategory: true },
    { Yazio: `/Publisher/publisher-yazio.rss`, isCategory: true },
    { Test: `/Publisher/publisher-test.rss`, isCategory: true },
    { Video: `/Publisher/publisher-video.rss`, isCategory: true },
    { Yemek: `/Publisher/publisher-yemek.rss`, isCategory: true },
    { Yaşam: `/Publisher/publisher-yasam.rss`, isCategory: true },
    { Seyahat: `/Publisher/publisher-seyahat.rss`, isCategory: true },
    { Sağlık: `/Publisher/publisher-saglik.rss`, isCategory: true },
    { Vitrin: `/Publisher/publisher-vitrin.rss`, isCategory: true },
    { Ekonomi: `/Publisher/publisher-ekonomi.rss`, isCategory: true },
    { Finans: `/Publisher/publisher-finans.rss`, isCategory: true },
    { 'Dizi & Film': `/Publisher/publisher-dizi+%26+film.rss`, isCategory: true },
    { Tv: `/Publisher/publisher-tv.rss`, isCategory: true },
    { Goygoy: `/Publisher/publisher-goygoy.rss`, isCategory: true },
    { Magazin: `/Publisher/publisher-magazin.rss`, isCategory: true },
    { Gaming: `/Publisher/publisher-gaming.rss`, isCategory: true },
    { Teknoloji: `/Publisher/publisher-teknoloji.rss`, isCategory: true },
    { Eğitim: `/Publisher/publisher-egitim.rss`, isCategory: true },
    { 'Genel Kültür': `/Publisher/publisher-genel+kultur.rss`, isCategory: true },
  ],
  en: [
    { Onedio: `/Publisher/publisher-onedio.rss`, isCategory: true },
    { News: `/Publisher/publisher-news.rss`, isCategory: true },
    { Entertainment: `/Publisher/publisher-entertainment.rss`, isCategory: true },
    { Life: `/Publisher/publisher-life.rss`, isCategory: true },
    { Sport: `/Publisher/publisher-sport.rss`, isCategory: true },
    { Technology: `/Publisher/publisher-technology.rss`, isCategory: true },
    { Culture: `/Publisher/publisher-culture.rss`, isCategory: true },
    { Business: `/Publisher/publisher-business.rss`, isCategory: true },
    { Other: `/Publisher/publisher-other.rss`, isCategory: true },
  ],
  ru: [
    { 'Onedio избранное': `/Publisher/publisher-onedio-izbrannoe.rss`, isCategory: true },
    { Россия: `/Publisher/publisher-rossiya.rss`, isCategory: true },
    { 'Вокруг света': `/Publisher/publisher-vokrug-sveta.rss`, isCategory: true },
    { Развлечение: `/Publisher/publisher-razvlechenie.rss`, isCategory: true },
    { Экономика: `/Publisher/publisher-ekonomika.rss`, isCategory: true },
    { Жизнь: `/Publisher/publisher-zhizn.rss`, isCategory: true },
    { Технология: `/Publisher/publisher-tekhnologiya.rss`, isCategory: true },
    { Культура: `/Publisher/publisher-kultura.rss`, isCategory: true },
    { Спорт: `/Publisher/publisher-sport.rss`, isCategory: true },
  ],
};

export const rssProxies = () => {
  const rssProxies = proxies[LANG].map((item) => {
    const path = Object.values(item)[0];
    const itemWithUrl = SITEMAP_URL + path;
    return itemWithUrl;
  });
  return rssProxies;
};

export const rssConfig = proxies[LANG];
